import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    title: 'Cases',
    loading: 'Loading cases...',
    empty: 'No cases available',
  },
  ru: {
    title: 'Кейсы',
    loading: 'Загрузка кейсов...',
    empty: 'Нет доступных кейсов',
  },
  uz: {
    title: 'Keyslar',
    loading: 'Keyslar yuklanmoqda...',
    empty: 'Mavjud keyslar yoʻq',
  },
  fa: {
    title: 'کیس‌ها',
    loading: 'در حال بارگذاری کیس‌ها...',
    empty: 'کیسی موجود نیست',
  },
  pt: {
    title: 'Caixas',
    loading: 'Carregando caixas...',
    empty: 'Nenhuma caixa disponível',
  },
  tr: {
    title: 'Kasalar',
    loading: 'Kasalar yükleniyor...',
    empty: 'Uygun kasa yok',
  },
  uk: {
    title: 'Кейси',
    loading: 'Завантаження кейсів...',
    empty: 'Немає доступних кейсів',
  },
  de: {
    title: 'Cases',
    loading: 'Cases werden geladen...',
    empty: 'Keine Cases verfügbar',
  },
  es: {
    title: 'Cajas',
    loading: 'Cargando cajas...',
    empty: 'No hay cajas disponibles',
  },
  pl: {
    title: 'Skrzynki',
    loading: 'Ładowanie skrzynek...',
    empty: 'Brak dostępnych skrzynek',
  },
});
